// extracted by mini-css-extract-plugin
export var button = "ToggleButton-module--button--3C8iZ";
export var button__content = "ToggleButton-module--button__content--1kc6N";
export var fadeInOpacity = "ToggleButton-module--fadeInOpacity--2okD0";
export var button__content__icon = "ToggleButton-module--button__content__icon--3lyGY";
export var active = "ToggleButton-module--active--2iCv5";
export var button__content__text = "ToggleButton-module--button__content__text--22OuV";